import * as Styled from './whatsapp_widget'

export { Styled }
